const GRADE_COLORS = {
  A: "#9013FE",
  B: "#007AFF",
  C: "#FB8832",
  D: "#E6E5E6"
};

export { GRADE_COLORS };
